var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 14.764v-2.348a5.002 5.002 0 0 0-6.771 3.084H13v1h1.025a5.07 5.07 0 0 0 0 1H13v1h1.229A5.002 5.002 0 0 0 21 21.584v-2.348a2.999 2.999 0 0 1-4.599-.736H19v-1h-2.959a3.018 3.018 0 0 1 0-1H19v-1h-2.599A2.999 2.999 0 0 1 21 14.764zM8 1l2.887 5H9v1h2v1H9v1h2v2h2V9h2V8h-2V7h2V6h-2v-.268L15.732 1h-2.31l-1.556 2.696L10.309 1H8zM5 12h2v1h2v2H4.929a.5.5 0 0 0 0 1H7.07a2.5 2.5 0 0 1 0 5H7v1H5v-1H3v-2h4.071a.5.5 0 0 0 0-1H4.93a2.5 2.5 0 0 1 0-5H5v-1z" })
  );
});